// src/assets/logos.js

// 🧩 Import all logo variants
import BlackRectangle from "./Black Rectangle Logo.png";
import BlackSquare from "./Black Square Logo.png";
import WhiteRectangle from "./White Rectangle Logo.png";
import WhiteSquare from "./White Square Logo.png";
import SaffronRectangle from "./Saffaron Rectangle Logo.png";
import SaffronSquare from "./Saffaron Square Logo.png";
import OriginalRectangle from "./Original Rectangle Logo.png";
import OriginalSquare from "./Original Square Logo.png";

// 🧠 Organized export for easy access
const Logos = {
  black: {
    rectangle: BlackRectangle,
    square: BlackSquare,
  },
  white: {
    rectangle: WhiteRectangle,
    square: WhiteSquare,
  },
  saffron: {
    rectangle: SaffronRectangle,
    square: SaffronSquare,
  },
  original: {
    rectangle: OriginalRectangle,
    square: OriginalSquare,
  },
};

// ✅ Support both default and named imports
export { Logos };
export default Logos;